import ApiClient from '@/shared/helpers/api/api.helper';
class UserDetails extends ApiClient {
  constructor() {
    super('iam');
  }
}

export default new UserDetails();
